<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Мои паузы в смене</h5>
      </div>
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!loading">
          <template v-if="records.length">
            <Chart :options="chartOptionsDelayed"/>
          </template>
          <template>
            <h5 class="text-center">Без пауз!</h5>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import {Chart} from "highcharts-vue";

export default {
  components: {Chart},
  data() {
    return {
      loading: false,
      records: [],
      chartOptionsDelayed: {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Паузы в работе за сегодня'
        },
        // subtitle: {
        //   text: 'Click the columns to view versions.'
        // },
        accessibility: {
          announceNewData: {
            enabled: true
          }
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          title: {
            text: 'Количество минут'
          }

        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              // format: '{point.y:.1f}%'
              format: '{point.y} min'
            }
          }
        },
        // tooltip: {
        //   headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        //   pointFormat: '<span style="color:{point.color}">{point.name}</span>: ' +
        //     '<b>{point.y:.2f}%</b> of total<br/>'
        // },
        series: [
          {
            name: 'Minutes',
            colorByPoint: true,
            data: [
              {
                name: 'Chrome',
                y: 63.06,
                drilldown: 'Chrome'
              },
            ]
          }
        ],
      }
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/new/user/absences');
      if (data.success) {
        this.records = data.records;
        this.chartOptionsDelayed.series[0].data = data.records.map((r) => {
          return {
            name: this.printDate(r.date_start, 'HH:mm'),
            y: r.duration
          }
        });
      } else {
        toastr['warning'](data.message || 'ошибка сервера');
      }
      this.loading = false;
    }
  }
}

</script>
